import React from 'react';
import Notes from 'Components/Notes';

export default function NotesSection ({notes, user, handleInputChange}) {
  if (notes || user.isInternal()) {
    return (
      <section className='scene_section'>
        <header>Notes</header>
        <Notes text={notes || ''} handleInputChange={handleInputChange('notes')} disabled={!user.isInternal()} />
      </section>
    );
  } else {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/Inspection/Edit/Report/Notes.jsx